import { Link } from 'react-router-dom';

import { Box, Button, Flex, Text } from '@spotify-internal/encore-web';
import {
  ChartBackground,
  ConfidenceLogo,
  ConfidenceWebsiteLinkEncore,
  Footer,
} from '@spotify/confidence-core-react';

import styles from './WelcomeScreen.module.css';

type WelcomeScreenProps = {
  variant: 'a' | 'b';
  onContinue: () => void;
};

export const WelcomeScreen = ({ variant, onContinue }: WelcomeScreenProps) => (
  <ChartBackground>
    <div className={styles.root}>
      <div className={styles.main}>
        <Flex direction="column" gap="looser-3" alignItems="center">
          <Link to="/" aria-label="Go to homepage">
            <ConfidenceLogo className={styles.logo} />
          </Link>
          <Flex direction="column" gap="tighter-3" alignItems="center">
            <Text as="h1" variant="titleLarge" className={styles.title}>
              Let&apos;s create your account
            </Text>
            <Text
              as="div"
              variant="bodyMedium"
              semanticColor="textSubdued"
              className={styles.description}
            >
              {variant === 'a' ? (
                <>
                  Use your work email, so your teammates can be in the same
                  workspace.
                  <br />
                  Free to start, no credit card needed.
                </>
              ) : (
                'Free to start, no credit card needed.'
              )}
            </Text>
          </Flex>
          <Flex direction="column" gap="tighter" alignItems="center">
            <Button
              variant="primary"
              colorSet="inverted"
              size="large"
              className={styles.button}
              data-testid="signup-continue"
              onClick={onContinue}
            >
              Continue
            </Button>
            <Box paddingBlockStart="tighter-2">
              <Text variant="bodySmall" semanticColor="textSubdued" as="div">
                For more information about how Spotify processes your data,
                please read our{' '}
                <ConfidenceWebsiteLinkEncore
                  route="/privacy-policy"
                  className={styles.privacyLink}
                >
                  Privacy Policy
                </ConfidenceWebsiteLinkEncore>
                .
              </Text>
            </Box>
          </Flex>
        </Flex>
      </div>
      <Footer />
    </div>
  </ChartBackground>
);
